import { createFileRoute } from "@tanstack/react-router";

import Settings from "./-components/ProxySettingsPage";

export const Route = createFileRoute("/_app/_dashboard/proxy/settings")({
  component: Settings,
});
